export default function ClassicSnakeIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#f7e3a6" />
      <path d="M2 14h60M2 26h60M2 38h60M2 50h60" stroke="#f0d68f" strokeWidth="6" />
      <path d="M12 50V30a6 6 0 0 1 6-6h14a6 6 0 0 0 6-6v-2" stroke="#5b2a86" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 50V30a6 6 0 0 1 6-6h14a6 6 0 0 0 6-6v-2" stroke="#9b5de5" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="38" cy="14" r="7" fill="#7b3fc4" />
      <circle cx="35" cy="12" r="2.4" fill="#fff" />
      <circle cx="41" cy="12" r="2.4" fill="#fff" />
      <circle cx="35" cy="11.4" r="1.1" fill="#111" />
      <circle cx="41" cy="11.4" r="1.1" fill="#111" />
      <circle cx="47" cy="44" r="6.5" fill="#EE2B3B" />
      <circle cx="53" cy="44" r="6.5" fill="#EE2B3B" />
      <path d="M50 38l1-5" stroke="#6B3B12" strokeWidth="2.5" strokeLinecap="round" />
      <ellipse cx="54.5" cy="34" rx="3.5" ry="1.8" fill="#3FB34F" transform="rotate(-25 54.5 34)" />
      <ellipse cx="46" cy="42" rx="1.6" ry="2.4" fill="#fff" opacity=".6" />
    </svg>
  );
}
